import React, { useState, useEffect } from "react";
// import "./Twheel.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  addbikenum,
  addbikedetails,
  addVahanData,
} from "../../../Redux/actions/NumBikeation";
import { NavbarJourney } from "../../Navbar/NavbarJourney";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Avatar,
  Card,
  DatePicker,
  Spin,
  Select,
} from "antd/lib";
import BikeImg from "../../../images/bike-insur.jpg";
import BikeFrontImg from "../../../images/bike-front-face.jpg";
import moment from "moment";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
import _ from "lodash";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
const { Meta } = Card;

export default function Twheelmake() {
  const bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );

  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [bikeNumDetail, setBikeNumdeail] = useState(bikenum);
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [bikemake, setBikeMake] = useState(BikeMakeData?.make);
  const [bikemodel, setModelSearch] = useState(BikeMakeData?.model);
  const [bikeVarient, setSelectVarient] = useState("");
  const [saveloading, setIsaveloading] = useState(false);
  // const [VehicleCode, setVehicleCode] = useState(BikeMakeData?.VehicleCoreCode);

  //console.log(bikenum)
  //console.log("vechicleData",vechicleData)

  useEffect(() => {
    //console.log(bikeNumDetail)
    form.setFieldsValue({
      BikeNumber: bikeNumDetail?.bike_number,
      registrationYear: vechicleData?.registration_date
        ? moment(vechicleData?.registration_date)
        : null,
    });
  }, [vechicleData, BikeMakeData]);

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);
  // const handleSearchMake = (searchText) => {
  //   setIsaveloading(true)
  //   const filteredOptions = Makeoptions.filter((option) =>
  //     option.toLowerCase().includes(searchText.toLowerCase())
  //   );
  //   //console.log(filteredOptions)
  //   setMakeData(filteredOptions);
  // };

  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    setIsaveloading(false);
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };
  //console.log(bikemake)

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);

  const handleSearch = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setModalData(filteredOptions);
  };

  // const onSelect = (data) => {
  //   //console.log("onSelect", data);
  //   setModelSearch(data);
  //   setIsaveloading(false)
  // };
  const ModelChange = (e) => {
    setModelSearch(e);
    setIsaveloading(false);
  };
  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        //console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  // const handleSearchVarient = (searchText) => {
  //   setIsaveloading(true)
  //   const filteredOptions = VarientOption.filter((option) =>
  //   option.toLowerCase().includes(searchText.toLowerCase())
  // );
  // setVarientData(filteredOptions);
  // }

  const VarientChange = (variant, option) => {
    // console.log(variant,option)
    setSelectVarient(variant);
    axiosInstance
      .get(
        `vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        //console.log(resp);
        dispatch(
          addbikedetails({
            ...BikeMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };
  // const VarientSelect = (selectedOption) => {
  //   console.log(selectedOption)
  // }
  // const onSelectVarient = (data) => {
  //   //console.log("onSelect", data);
  //   setSelectVarient(data);
  //   setIsaveloading(false)
  // };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  //  const onDateChange = (date, dateString) => {
  //   //console.log(date);
  //   // console.log(dateString)
  //   //setRegDate(dateString)
  // };
  const debouncedHandleInputChange = _.debounce((e) => {
    setIsaveloading(true);
    const inputValue = e.target.value.toUpperCase();
    setBikeNumdeail({ ...bikeNumDetail, bike_number: inputValue });
    const updatedVal = {
      ...bikeNumDetail,
      bike_number: inputValue,
    };
    axiosInstance
      .post("getVehicleDetails", { vehicleNumber: inputValue })
      .then((res) => {
        //console.log(res);
        let bikeresult = res?.data?.data;
        //console.log(bikeresult)
        dispatch(addVahanData(bikeresult));
        dispatch(addbikenum(updatedVal));
        setIsaveloading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsaveloading(false);
      });
  }, 500);

  const handleInputChange = (e) => {
    debouncedHandleInputChange(e);
    form.setFieldsValue({ BikeNumber: e.target.value.toUpperCase() });
  };

  const onFinish = (values) => {
    //console.log('values',values)
    setLoading(true);
    values.registrationYear = moment(values.registrationYear).format(
      "YYYY-MM-DD"
    );
    //console.log(values);

    dispatch(
      addbikedetails({
        ...BikeMakeData,
        make: values.bikeMake,
        model: values.bikeModel,
        year: values.registrationYear,
        varbike: values.bikeVarient,
        // VehicleCoreCode: VehicleCode,
      })
    );
    dispatch(addbikenum(bikeNumDetail));
    const updatedVahanData = {
      ...vechicleData,
      registration_date: values.registrationYear,
    };
    dispatch(addVahanData(updatedVahanData));
    setTimeout(() => {
      setLoading(false);
      history.push("/policystepbike");
    }, 1000);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <NavbarJourney />
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <Form
              layout={formLayout}
              form={form}
              className="ant-quote-form col-xl-6 col-lg-6 col-md-6"
              requiredMark={false}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <h6 className="ant-quote-form-head">Enter Vehicle Details</h6>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="Bike Number"
                    name="BikeNumber"
                    rules={[
                      {
                        pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                        message: "Invalid Vehicle No",
                      },
                      { required: true, message: "Enter Vehicle No" },
                    ]}
                  >
                    <Input
                      onChange={handleInputChange}
                      placeholder="Enter Bike Number (eg. DL1SAB1234)"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeMake"
                    label="Select Make"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Make",
                      },
                    ]}
                    initialValue={BikeMakeData?.make}
                  >
                    <Select
                      placeholder="Select Make"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={MakeData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      // onChange={(e)=>onSelectMake(e)}
                      onSelect={(e) => onSelectMake(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeModel"
                    label="Select Model"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Model",
                      },
                    ]}
                    initialValue={BikeMakeData?.model}
                  >
                    <Select
                      placeholder="Select Model"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={ModalData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      // onChange={(e)=>ModelChange(e)}
                      onSelect={(e) => ModelChange(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeVarient"
                    label="Select Variant"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Variant",
                      },
                    ]}
                    initialValue={BikeMakeData?.varbike}
                  >
                    <Select
                      placeholder="Select Variant"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={VarientData?.map((p, index) => ({
                        key: index,
                        value: p.variant,
                        label: p.customized_variant,
                      }))}
                      onChange={(variant, option) =>
                        VarientChange(variant, option)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Registration Year"
                    name="registrationYear"
                    rules={[
                      {
                        required: true,
                        message: "please input Registration Year",
                      },
                    ]}
                    //initialValue={vechicleData?.registration_date ? moment(vechicleData?.registration_date) : null}
                  >
                    <DatePicker
                      style={{ width: "100%", padding: "8px" }}
                      format="YYYY-MM-DD"
                      // onChange={onDateChange}
                      placeholder="Select Registration Date"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item {...buttonItemLayout}>
                    <Button
                      style={{ width: "100%" }}
                      loading={loading}
                      type="primary"
                      htmlType="submit"
                    >
                      GET QUOTES
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            {/* { !isEdit ? (  */}
            <div className="col-xl-5 col-lg-6 col-md-6 bike-info-quotebef">
              <h1 className="bike-quotebef-txt">Your Vechicle Details</h1>
              <Card>
                <Spin spinning={saveloading}>
                  <Meta
                    avatar={<Avatar src={BikeFrontImg} />}
                    title={
                      <div className="meta-title-ant">
                        <p className="mb-0">
                          {BikeMakeData?.make ? BikeMakeData.make : bikemake}
                        </p>
                        <p className="mb-0">{bikeNumDetail?.bike_number}</p>
                      </div>
                    }
                    description={
                      <div className="meta-description-ant">
                        <p className="mb-0">
                          {BikeMakeData?.model ? BikeMakeData.model : bikemodel}
                        </p>
                        <p className="mb-0 text-end">
                          {BikeMakeData?.varbike
                            ? BikeMakeData.varbike
                            : bikeVarient}
                        </p>
                      </div>
                    }
                  />
                </Spin>
              </Card>
              <div className="vehdetail-img">
                <LazyLoadImage
                  effect="blur"
                  style={{ width: "85%", borderRadius: "10px" }}
                  alt="one"
                  src={BikeImg}
                />
                {/* <img src={BikeImg} style={{width: "85%", borderRadius: "10px",}}></img> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
